// extracted by mini-css-extract-plugin
export var downArrow = "_b6-0";
export var infoTooltipIcon = "_b6-3";
export var label = "_b6-1";
export var optionCard = "_b6-4";
export var upArrow = "_b6-2";